import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';
import { partnerPortalAPI } from '../../lib/api';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../ui/dialog';
import { Button } from '../ui/button';
import { Checkbox } from '../ui/checkbox';

export const ReferDialog = ({ job, onClose, onDone }) => {
  const [cands, setCands] = useState(null);
  const [sel, setSel] = useState([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!job) return;
    setSel([]); setCands(null);
    partnerPortalAPI.candidates().then((r) => setCands(r.data)).catch(() => setCands([]));
  }, [job]);

  const toggle = (id) => setSel((s) => (s.includes(id) ? s.filter((x) => x !== id) : [...s, id]));

  const send = async () => {
    setSaving(true);
    try {
      const r = (await partnerPortalAPI.refer(job.id, sel)).data;
      toast.success(`${r.indicados} indicado(s)${r.ja_inscritos ? ` · ${r.ja_inscritos} já estavam na vaga` : ''}`);
      onDone(); onClose();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Erro ao indicar');
    } finally { setSaving(false); }
  };

  return (
    <Dialog open={!!job} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg max-h-[85vh] overflow-y-auto" data-testid="partner-refer-dialog">
        <DialogHeader>
          <DialogTitle>Indicar para: {job?.titulo}</DialogTitle>
          <DialogDescription>A empresa verá a indicação da sua entidade e o candidato recebe um aviso no app.</DialogDescription>
        </DialogHeader>
        {!cands ? <Loader2 className="w-6 h-6 animate-spin text-amber-500 mx-auto" /> : cands.length === 0 ? (
          <p className="text-sm text-slate-500">Você ainda não tem candidatos vinculados.</p>
        ) : (
          <div className="space-y-1">
            {cands.map((c) => (
              <label key={c.id} className="flex items-center gap-3 p-2 rounded hover:bg-slate-50 cursor-pointer" data-testid={`refer-candidate-${c.id}`}>
                <Checkbox checked={sel.includes(c.id)} onCheckedChange={() => toggle(c.id)} data-testid={`refer-check-${c.id}`} />
                <span className="text-sm"><span className="font-medium">{c.nome}</span>{c.cargos?.length ? <span className="text-slate-500"> · {c.cargos.join(', ')}</span> : null}</span>
              </label>
            ))}
          </div>
        )}
        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={saving}>Cancelar</Button>
          <Button onClick={send} disabled={saving || sel.length === 0} className="bg-amber-500 hover:bg-amber-600" data-testid="partner-refer-submit">
            {saving && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}Indicar {sel.length || ''}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
